module.exports = __webpack_public_path__ + "img/image-upload-icon.e151647.svg";